/**
 * 上下箭头 + 颜色 — 用于 KPI / 表格里展示环比 / 变化方向。
 * 业务约定：投诉量 up = 红 (差); 口碑分 / 满意 up = 绿 (好)。invertColors=true 反转语义。
 */

interface TrendArrowProps {
  value: number; // 正负或绝对值百分比（小数：0.05 = 5%）
  /** true 时 up=绿、down=红（用于 口碑分 / 满意度等"高越好"指标） */
  invertColors?: boolean;
  /** 显示格式：'pct'=0.0% / 'pp'=+1.2pp / 'abs'=原值 */
  format?: 'pct' | 'pp' | 'abs';
  className?: string;
}

export default function TrendArrow({
  value,
  invertColors = false,
  format = 'pct',
  className = '',
}: TrendArrowProps) {
  const isUp = value > 0;
  const isFlat = value === 0;

  const upGood = invertColors; // up = good ?
  let color: string;
  if (isFlat) color = 'text-slate-500';
  else if (isUp) color = upGood ? 'text-risk-low' : 'text-risk-major';
  else color = upGood ? 'text-risk-major' : 'text-risk-low';

  const arrow = isFlat ? '—' : isUp ? '↑' : '↓';

  let label: string;
  if (format === 'pct') label = `${(value * 100).toFixed(1)}%`;
  else if (format === 'pp') label = `${value >= 0 ? '+' : ''}${value.toFixed(1)}pp`;
  else label = value.toFixed(2);

  return (
    <span className={`inline-flex items-center gap-1 text-[12px] ${color} ${className}`}>
      <span>{arrow}</span>
      <span>{Math.abs(value) > 0 ? label.replace('-', '') : label}</span>
    </span>
  );
}
